import { useState } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import { v4 } from '@rotra-air-ocean/rotranext-shared-code';

import { Modal } from '../Modal.jsx';

import { ID_RE, KIND_HELP } from './constants';
import { KindPicker } from './KindPicker';

export function AddStepModal({
  existingIds,
  onCancel,
  onAdd,
}: {
  existingIds: string[];
  onCancel: () => void;
  onAdd: (id: string, kind: v4.StepKind) => void;
}) {
  const [id, setId] = useState('');
  const [kind, setKind] = useState<v4.StepKind>('userInput');
  const trimmed = id.trim();
  const error =
    trimmed && !ID_RE.test(trimmed)
      ? 'Use letters, numbers and underscores only.'
      : existingIds.includes(trimmed)
      ? 'A step with that id already exists.'
      : null;
  const canAdd = Boolean(trimmed) && !error;

  return (
    <Modal
      title="Add step"
      onClose={onCancel}
      actions={
        <>
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            variant="contained"
            disabled={!canAdd}
            onClick={() => canAdd && onAdd(trimmed, kind)}
          >
            Add step
          </Button>
        </>
      }
    >
      <TextField
        label="Step id"
        autoFocus
        placeholder="e.g. collect_details"
        value={id}
        onChange={(e) => setId(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && canAdd) {
            onAdd(trimmed, kind);
          }
        }}
        error={Boolean(error)}
        helperText={error ?? ' '}
      />
      <Typography variant="subtitle2">Kind</Typography>
      <KindPicker value={kind} onChange={setKind} />
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        {KIND_HELP[kind]}
      </Typography>
    </Modal>
  );
}
